import React from "react";
import _ from "lodash";
import { Table } from "semantic-ui-react";
import Address from "../searchresults/Address";

const getDateRangeAddress = (
  title,
  dateFrom,
  dateTo,
  addressNode,
  index,
  props
) => (
  <Table.Row
    key={`row_date_range_${index}`}
    className="report-sub-section-header"
  >
    <Table.HeaderCell colSpan={5} width={10}>
      {`${title} `}
      <Address
        addressNode={addressNode}
        {...props}
        fullAddress={_.get(addressNode, "fullAddress[0]._")}
        ignoreLine1
        noBreakIconsAndText
      />
    </Table.HeaderCell>
    <Table.HeaderCell width={6} className={"text-right"}>
      {`${dateFrom}${dateFrom !== "" ? "-" : ""}${dateTo}`}
    </Table.HeaderCell>
  </Table.Row>
);

export default getDateRangeAddress;



// WEBPACK FOOTER //
// ./src/components/reports/DateRangeAddress.js